module.exports = __webpack_public_path__ + "img/rank1.ec3060d5.png";